import { render } from "./ObjetivoComisionCreate.vue?vue&type=template&id=6a0a55c8&scoped=true"
import script from "./ObjetivoComisionCreate.vue?vue&type=script&lang=js"
export * from "./ObjetivoComisionCreate.vue?vue&type=script&lang=js"

import "./ObjetivoComisionCreate.vue?vue&type=style&index=0&id=6a0a55c8&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0a55c8"]])

export default __exports__